import './FloatingSideBar.css'
import { Icon } from 'semantic-ui-react';

function FloatingSideBar({refs}){

  const menuList = [
    { name: 'About', iconName: 'home', ref: refs.aboutRef },
    { name: 'Education', iconName: 'book', ref: refs.educationRef },
    { name: 'Skills', iconName: 'code', ref: refs.skillsRef },
    { name: 'Blog', iconName: 'blogger b', ref: refs.blogRef },
    { name: 'Contact', iconName: 'whatsapp square', ref: refs.contactRef },
];

const handleScroll = (sectionRef) => {
  if (sectionRef.current) {
    sectionRef.current.scrollIntoView({
      behavior: 'smooth',
    });
  }
};
    return (
        <div className='floatingIconWrapper'>
            {
                menuList.map((item, index) => {
                    return (
                        <div className='floatingmenuIteam' key={index} onClick={() => handleScroll(item.ref)}>
                            <Icon size='large' color='grey' name={item.iconName} link onClick={() => handleScroll(item.ref)} />
                        </div>
                        
                    )
                })
            }
        </div>
    )
}

export default FloatingSideBar;